import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { device } from "../../helpers";

const Container = styled.div`
    user-select: none;
    position: absolute;
    left: 32px;
    top: 10px;
    color: #d2d2d2;

    @media ${device.phone} {
        position: relative;
        left: auto;
        top: auto;
        text-align: center;
        width: 100%;
        margin-bottom: 5px;
    } ;
`;

const LinkA = styled(Link)`
    display: inline-block;
    margin: 0 10px;
    font-size: 14px;
    font-weight: 500;
    color: #8e8e8e;
    text-decoration: none;

    span {
        font-weight: 500;
    }
`;

const A = styled.a.attrs({
    target: "_blank",
})`
    display: inline-block;
    margin: 0 10px;
    font-size: 14px;
    font-weight: 500;
    color: #8e8e8e;
    text-decoration: none;

    span {
        font-weight: 500;
    }

    &:first-child {
        margin-right: 0;
    }

    &:last-child {
        margin-left: 0;
    }

    &:hover span {
        color: #000;
    }
`;

function TopMenu() {
    return (
        <Container>
            <LinkA to="/app/">
                <FormattedMessage id="topMenu.homepage" />
            </LinkA>
            .
            <LinkA to="/app/copyrights">
                <FormattedMessage id="topMenu.copyrights" />
            </LinkA>
            .
            <LinkA to="/app/terms">
                <FormattedMessage id="topMenu.terms" />
            </LinkA>
            .
            <LinkA to="/app/b-146-اُردو-کُتب-کی-اشاعات">
                <FormattedMessage id="topMenu.help" />
            </LinkA>
            .
            <A href="https://www.facebook.com/urdupub/" target="_blank">
                <FormattedMessage id="topMenu.contact" />
            </A>
        </Container>
    );
}

export default TopMenu;
